export const datadogClientTokenDev = 'pub150b2230647bd4475b8ea32144d22455';
export const datadogClientTokenProd = 'pubd8d3feab5e9c7bb46a1189d01aa8cb50';
